var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.844 6.433H15.2V6.4H8v3.2h4.521A4.798 4.798 0 0 1 3.2 8 4.8 4.8 0 0 1 8 3.2c1.224 0 2.337.462 3.184 1.216l2.263-2.263A7.963 7.963 0 0 0 8 0a8 8 0 1 0 7.844 6.433z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.922 4.276 2.629 1.928A4.798 4.798 0 0 1 8 3.2c1.224 0 2.337.462 3.184 1.216l2.263-2.263A7.963 7.963 0 0 0 8 0 7.995 7.995 0 0 0 .922 4.276z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16c2.066 0 3.944-.79 5.364-2.077l-2.476-2.095A4.764 4.764 0 0 1 8 12.8a4.798 4.798 0 0 1-4.513-3.178l-2.609 2.01A7.994 7.994 0 0 0 8 16z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.844 6.433H15.2V6.4H8v3.2h4.521a4.816 4.816 0 0 1-1.635 2.228h.002l2.476 2.095C13.188 14.082 16 12 16 8c0-.536-.055-1.06-.156-1.567z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.2953bfee26eb83b5e441ea5bea137763.svg";
export { ForwardRef as ReactComponent };